import React, { useContext, useEffect, useRef, useState } from "react";
import { FaWheelchair } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import {
  getValidPlateNumber,
  setValidPlateNumber,
} from "../../utils/plateLetterHandler";
import MaskedInput from "react-text-mask";
import { p2e } from "../../utils/functions";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import globalContext from "../../Contexts/GlobalContext";
import useRequestHeader from "../../hooks/useRequestHeader";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import ColoredLoader from "../coloredLoader/ColoredLoader";

export default function SetNewViolationPlate({
  setIsNewViolationPlateOpen,
  setViolationPlate,
  setViolationCarLogo,
  setViolationCarModel,
  setIsPlateModalOpen,
  plateModalLetter,
  setPlateModalLetter,
}) {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();

  const [isLoadingFindCar, setIsLoadingFindCar] = useState(false);
  const plk1 = useRef();
  const plk2 = useRef();
  const plk3 = useRef();
  const [pInp1, setPInp1] = useState("");
  const [pInp2, setPInp2] = useState("");
  const [pInp3, setPInp3] = useState("");

  useEffect(() => {
    if (plateModalLetter && pInp1) {
      plk2.current.inputElement.focus();
    }
  }, [plateModalLetter]);

  const changeNewViolationPlate = () => {
    if (!isLoadingFindCar) {
      setIsLoadingFindCar(true);
      const config = {
        headers: requestHeader,
      };
      axios
        .post(
          `${BASE_URL}/car/findCar`,
          {
            plate: setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3),
            mode: "info",
          },
          config
        )
        .then((res) => {
          var responseMode = res?.data?.Mode;
          var responseMessage = res?.data?.Message;
          switch (responseMode) {
            case SERVERMODE.REQUEST_OK: {
              if (res?.data?.Data === "false") {
                setViolationCarLogo("");
                setViolationCarModel("");
              } else {
                setViolationCarLogo(res?.data?.Data?.srcLogo);
                setViolationCarModel(res?.data?.Data?.model);
              }
              setViolationPlate(
                setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
              );
              setIsNewViolationPlateOpen(false);
              setPInp1("");
              setPInp2("");
              setPInp3("");
              setPlateModalLetter("");
              break;
            }
            default: {
              setViolationCarLogo("");
              setViolationCarModel("");
              setViolationPlate(
                setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
              );
              setIsNewViolationPlateOpen(false);
              setPInp1("");
              setPInp2("");
              setPInp3("");
              setPlateModalLetter("");
              handleServerMode(
                responseMode,
                responseMessage,
                contextData,
                cookies,
                removeCookies,
                navigate
              );
            }
          }
          setIsLoadingFindCar(false);
        })
        .catch((err) => {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
          setIsLoadingFindCar(false);
          setViolationPlate(
            setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
          );
          setIsNewViolationPlateOpen(false);
          setPInp1("");
          setPInp2("");
          setPInp3("");
          setPlateModalLetter("");
        });
    }
  };
  return (
    <>
      <div
        className={`absolute h-[100vh]  w-[100vw] z-[1000] backdrop-blur-sm`}
        onClick={() => {
          setIsNewViolationPlateOpen(false);
        }}
      ></div>

      <div
        className="bg-[#02161D] absolute w-full  font-font_primary_A h-auto px-[8vw] py-[6vw] rounded-t-[2.8vw] z-[1001] up "
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="w-full flex items-center justify-between font-font_primary_A  text-[#FFF]">
          <span className="text-[4vw]">ورود پلاک</span>
          <span
            className="text-[6vw]"
            onClick={() => {
              setIsNewViolationPlateOpen(false);
            }}
          >
            <IoClose />
          </span>
        </div>
        <div className="w-full text-start font-font_primary_A text-color-primary-A text-[3vw] mt-[5vw]">
          پلاک خودرو مدنظر خودرا وارد نمایید
        </div>
        <div className="w-full flex items-center justify-center gap-x-[2vw] mt-[6vw]  text-[4vw] font-bold text-color-primary-D">
          <div className="relative flex items-center justify-center">
            <svg
              width="81vw"
              height="15vw"
              viewBox="0 0 1164 185"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.4531 0H1150.81C1154.48 0 1157.41 1.14198 1160.34 2.85493C1162.54 4.5679 1164 7.42284 1164 9.70679V175.293C1164 177.577 1162.54 180.432 1160.34 182.145C1157.41 183.858 1154.48 185 1150.81 185H12.4531C9.52297 185 5.86028 183.858 3.66268 182.145C1.46507 180.432 0 177.577 0 175.293V9.70679C0 7.42284 1.46507 4.5679 3.66268 2.85493C5.86028 1.14198 9.52297 0 12.4531 0ZM104.02 3.99691V181.003H887.834V3.99691H104.02ZM98.8924 181.003V3.99691H12.4531C10.2555 3.99691 8.79043 4.5679 7.32536 5.70987C5.86028 6.85185 5.12776 7.99382 5.12776 9.70679V175.293C5.12776 176.435 5.86028 178.148 7.32536 179.29C8.79043 180.432 10.2555 181.003 12.4531 181.003H98.8924ZM892.962 3.99691V181.003H1150.81C1153.01 181.003 1155.21 180.432 1156.67 179.29C1157.41 178.148 1158.87 176.435 1158.87 175.293V9.70679C1158.87 7.99382 1157.41 6.85185 1156.67 5.70987C1155.21 4.5679 1153.01 3.99691 1150.81 3.99691H892.962Z"
                fill="#00FFF2"
              />
              <path
                d="M99 181V4H12.3438C10.1406 4 8.67188 4.57097 7.20314 5.71289C5.73438 6.85483 5 7.99676 5 9.70967V175.29C5 176.432 5.73438 178.145 7.20314 179.287C8.67188 180.429 10.1406 181 12.3438 181H99Z"
                fill="#00FFF2"
                fill-opacity="0.35"
              />
              <path
                d="M15 138.937V117H18.6635V138.937H15ZM33.3168 138.937V117H44.307C45.7724 117 47.9704 117 48.7031 117.577C50.1684 117.577 50.9011 118.732 51.6338 119.309C52.3665 120.464 52.3665 121.618 52.3665 122.773C52.3665 124.505 51.6338 125.66 50.9011 126.814C49.4357 127.969 47.9704 128.546 45.7724 128.546C46.505 129.124 47.2377 129.701 47.9704 129.701C48.7031 130.856 49.4357 131.433 50.1684 132.588L54.5643 138.937H50.1684L47.2377 134.32C46.505 133.164 45.7724 132.01 45.0397 131.433C44.307 130.278 43.5743 130.278 43.5743 129.701C42.8416 129.701 42.109 129.124 42.109 129.124C41.3763 129.124 40.6436 129.124 39.9109 129.124H36.2475V138.937H33.3168ZM36.2475 126.814H43.5743C45.0397 126.814 45.7724 126.237 46.505 126.237C47.2377 125.66 47.9704 125.66 48.7031 125.082C48.7031 124.505 49.4357 123.35 49.4357 122.773C49.4357 121.618 48.7031 121.041 47.9704 120.464C47.2377 119.886 45.7724 119.309 44.307 119.309H36.2475V126.814ZM70.6832 173V151.062H73.6139L86.0695 168.381V151.062H89V173H86.0695L73.6139 155.68V173H70.6832ZM45.7724 173L54.5643 151.062H58.2277L67.7525 173H64.0891L61.8911 166.649H51.6338L48.7031 173H45.7724ZM52.3665 163.762H60.4257L58.2277 157.989C57.495 156.257 56.7624 154.526 56.0297 153.37C56.0297 154.526 55.297 156.257 55.297 157.413L52.3665 163.762ZM23.792 173V151.062H34.7822C36.9802 151.062 38.4456 151.062 39.1783 151.639C40.6436 152.216 41.3763 152.794 42.109 153.948C42.8416 154.526 42.8416 155.68 42.8416 156.835C42.8416 158.567 42.8416 159.721 41.3763 160.876C40.6436 162.03 38.4456 162.608 36.2475 163.186C36.9802 163.186 37.7129 163.762 38.4456 164.34C39.1783 164.917 39.9109 166.072 40.6436 167.227L45.0397 173H41.3763L37.7129 168.381C36.9802 167.227 36.2475 166.072 35.5149 165.495C34.7822 164.917 34.7822 164.34 34.0495 163.762C33.3168 163.762 33.3168 163.762 32.5842 163.186C32.5842 163.186 31.8515 163.186 31.1188 163.186H27.4554V173H23.792ZM27.4554 160.876H34.0495C35.5149 160.876 36.2475 160.876 37.7129 160.299C38.4456 160.299 39.1783 159.721 39.1783 159.144C39.9109 158.567 39.9109 157.989 39.9109 156.835C39.9109 156.257 39.1783 155.103 38.4456 154.526C37.7129 153.948 36.2475 153.37 34.7822 153.37H27.4554V160.876ZM15 173V151.062H18.6635V173H15ZM57.495 138.937V135.474H61.1584V138.937H57.495ZM24.5247 138.937V135.474H27.4554V138.937H24.5247Z"
                fill="#00FFF2"
              />
            </svg>

            <MaskedInput
              mask={[/[۰۱۲۳۴۵۶۷۸۹0-9]/, /[۰۱۲۳۴۵۶۷۸۹0-9]/]}
              guide={false}
              ref={plk3}
              value={pInp3}
              type="tel"
              dir="ltr"
              className={`absolute top-1/2 -translate-y-1/2 right-[4vw] w-[12vw] h-[6.5vw] bg-[rgba(226,227,229,0.2)] text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText flex items-center justify-center text-center text-[5.5vw] focus:text-[5.5vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw] `}
              onChange={(e) => {
                setPInp3(p2e(e.target.value));
                if (
                  setValidPlateNumber(
                    pInp1,
                    plateModalLetter,
                    pInp2,
                    e.target.value
                  ).length === 9
                ) {
                  plk3.current.inputElement.blur();
                }
              }}
              onClick={() => {
                if (pInp2.length < 3) {
                  plk2.current.inputElement.focus();
                }
                if (pInp1.length < 2) {
                  plk1.current.inputElement.focus();
                }
              }}
              onKeyUp={(e) => {
                if (e.key === "Backspace") {
                  if (e.target.value === "") {
                    plk2.current.inputElement.focus();
                  }
                }
              }}
            />

            <MaskedInput
              mask={[/[۰۱۲۳۴۵۶۷۸۹0-9]/, /[۰۱۲۳۴۵۶۷۸۹0-9]/, /[۰۱۲۳۴۵۶۷۸۹0-9]/]}
              guide={false}
              ref={plk2}
              value={pInp2}
              type="tel"
              dir="ltr"
              className={`absolute top-1/2 -translate-y-1/2  right-[22vw] w-[18vw] h-[6.5vw] bg-[rgba(226,227,229,0.2)] text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText flex items-center justify-center text-center text-[5.5vw] focus:text-[5.5vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw]`}
              onChange={(e) => {
                setPInp2(p2e(e.target.value));
                if (e.target.value.length === 3) {
                  plk3.current.inputElement.focus();
                }
                // if (e.target.value === "") {
                //   setPlateModalLetter("");
                //   plk1.current.inputElement.focus();
                // }
              }}
              onClick={() => {
                if (pInp1.length < 2) {
                  plk1.current.inputElement.focus();
                }
              }}
              onKeyUp={(e) => {
                if (e.key === "Backspace") {
                  if (e.target.value === "") {
                    setPlateModalLetter("");
                    plk1.current.inputElement.focus();
                  }
                }
              }}
            />
            <div
              className={`absolute top-1/2 -translate-y-1/2 right-[43vw] w-[12vw] h-[6.5vw]   z-50 ml-[2vw]  bg-[rgba(226,227,229,0.2)] flex items-center justify-center text-center text-color-primary-ImportBoxText  text-[5vw] font-font_primary_A outline-none leading-[5.9vw]`}
              onClick={() => {
                if (pInp1.length < 2) {
                  plk1.current.inputElement.focus();
                }
                if (pInp1.length === 2) {
                  setIsPlateModalOpen(true);
                }
              }}
            >
              <span>
                {plateModalLetter === "&" ? (
                  <FaWheelchair size={16.5} />
                ) : (
                  plateModalLetter
                )}
              </span>
            </div>

            <MaskedInput
              mask={[/[۰۱۲۳۴۵۶۷۸۹0-9]/, /[۰۱۲۳۴۵۶۷۸۹0-9]/]}
              guide={false}
              ref={plk1}
              value={pInp1}
              type="tel"
              dir="ltr"
              className={`absolute top-1/2 -translate-y-1/2 right-[58vw] w-[12vw] h-[6.5vw] bg-[rgba(226,227,229,0.2)] text-color-primary-ImportBoxText  focus:text-color-primary-ImportBoxText flex items-center justify-center text-center focus:text-center text-[5.5vw] focus:text-[5.5vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none z-50 leading-[5.9vw] `}
              onChange={(e) => {
                setPInp1(p2e(e.target.value));
                if (e.target.value.length === 2) {
                  setIsPlateModalOpen(true);
                  plk1.current.inputElement.blur();
                }
              }}
            />
          </div>
        </div>

        <button
          disabled={
            setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
              .length === 9
              ? false
              : true
          }
          className={`w-full h-[10vw] flex items-center justify-center rounded-[1.8vw] border-[1px] ${
            setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
              .length === 9
              ? "border-color-primary-D text-color-primary-D"
              : "border-color-primary-C3 text-color-primary-C3"
          }  text-[3.5vw]  font-font_primary_A mt-[6vw]`}
          onClick={changeNewViolationPlate}
        >
          {isLoadingFindCar ? (
            <ColoredLoader size={30} color="#00F7FF" />
          ) : (
            " تایید و ثبت"
          )}
        </button>
      </div>
    </>
  );
}
